import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../sanity/client";
import EventCard from "./subComponents/eventCard";
import { ring } from "ldrs";

const RECENT_EVENTS_QUERY = `*[_type == "event"] {
  _id,
  name,
  slug,
  date,
  eventType,
  venue->{ name },
  "image": image.asset->url
}`;

// The 4 events chronologically closest to right now, whichever side of
// "now" they fall on — this is what lets the card tags read Past/Upcoming
// meaningfully instead of always showing the same "upcoming only" list.
// Display order: soonest-upcoming first, then most-recently-past last.
function pickRecentEvents(events, count = 4) {
  const now = Date.now();
  const withDelta = events
    .filter((event) => event.date)
    .map((event) => ({
      ...event,
      delta: Math.abs(new Date(event.date).getTime() - now),
    }));

  return withDelta
    .sort((a, b) => a.delta - b.delta)
    .slice(0, count)
    .sort((a, b) => {
      const aTime = new Date(a.date).getTime();
      const bTime = new Date(b.date).getTime();
      const aFuture = aTime >= now;
      const bFuture = bTime >= now;
      if (aFuture !== bFuture) return aFuture ? -1 : 1;
      return aFuture ? aTime - bTime : bTime - aTime;
    });
}

const HomeEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  ring.register();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await client.fetch(RECENT_EVENTS_QUERY);
        setEvents(pickRecentEvents(data));
      } catch (err) {
        console.error("Error fetching events:", err);
        setError("Couldn't load events right now.");
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  return (
    <section className="homeEvents">
      <div className="homeEventsHeader">
        <div>
          <h2 className="homeEventsHeading">Recent events</h2>
          <p className="homeEventsSubcopy">
            A look at what's happened lately and what's coming up next.
          </p>
        </div>

        <Link to="/events" className="homeEventsViewAll">
          View all events
        </Link>
      </div>

      {loading && (
        <div className="homeEventsLoading">
          <l-ring size="32" stroke="4" bg-opacity="0" speed="2" color="#1A1A1A"></l-ring>
        </div>
      )}

      {!loading && error && <p className="homeEventsMessage">{error}</p>}

      {!loading && !error && events.length === 0 && (
        <p className="homeEventsMessage">
          No events on the calendar yet. Check back soon.
        </p>
      )}

      {!loading && !error && events.length > 0 && (
        <div className="homeEventsGrid">
          {events.map((event) => (
            <EventCard event={event} key={event._id} />
          ))}
        </div>
      )}
    </section>
  );
};

export default HomeEvents;
